import create from 'zustand';
import {SortParams} from "@/components/SortIndicator";

export const DrmPfInformationListHeader = [
  {
    headerName:'管理番号',
    sortItemName: 'id',
  },
  {
    headerName:'情報区分',
    sortItemName: 'drm_pf_information_type_id',
  },
  {
    headerName:'タイトル',
    sortItemName: 'title',
  },
  {
    headerName:'内容',
    sortItemName: 'body',
  },
  {
    headerName:'公開日',
    sortItemName: 'release_date',
  },
];

const initState = {
  queryParams: undefined,
  sortParams: {} as SortParams,
  doSort: () => {
  },
}

type DrmPfInformationListStore = {
  queryParams: any | undefined;
  setQueryParams: (any: any | undefined) => void;
  sortParams: SortParams;
  setSortParams: (sortParams: SortParams) => void;
  doSort: (sortParams: SortParams) => void;
  setDoSort: (func: DrmPfInformationListStore['doSort']) => void;
};

// 検索条件の保持に使用
export const useDrmPfInformationListStore = create<DrmPfInformationListStore>((set) => ({
  ...initState,
  setQueryParams: (queryParams) =>
    set((state) => ({
      queryParams: queryParams,
    })),
  setSortParams: (sortParams) =>
    set((state) => ({
      sortParams: sortParams,
    })),
  setDoSort: (doSort) =>
    set((state) => ({
      doSort: doSort,
    }))
}));
